<template>
  <div
    :class="hasNavigation ? 'wrapper' : ''"
    :style="{ '--uncollapsed-width': uncollapsedWidth }"
  >
    <div id="nav">
      <header-app v-if="hasNavigation"></header-app>
    </div>

    <div :class="hasNavigation ? 'flex-page-container' : ''">
      <div class="side-menu-container" v-if="hasNavigation">
        <!-- Sidebar -->
        <!-- <Sidebar /> -->
        <side-bar-menu
          :menu="filteredMenu"
          :footerMenu="footerMenu"
          :theme="'suez-theme'"
          :width="uncollapsedWidth"
          :relative="true"
        />
      </div>
      <div :class="hasNavigation ? 'content-container' : ''">
        <!-- Content  #f1f5f9;-->
        <router-view />
      </div>
    </div>
  </div>
</template>

<script setup>
import headerApp from "./components/header.vue";
</script>

<script>
import { defineComponent, computed } from "vue";
import * as wjcCore from "@grapecity/wijmo";
import Environment from "@/../configs";
import SlaveCommunicationHandler from "@supervision/vue-components/communication/SlaveCommunicationHandler.js";
import { useI18n } from "vue-i18n";
import SideBarMenu from "@supervision/vue-components/components/Layout/SideBar/SidebarMenu";
import SearchResult from "@supervision/vue-components/contracts/SearchResult.js";
import SearchService from '@/services/SearchService.js';

export default defineComponent({
  provide() {
    return {
      lang: computed(() => this.lang),
      accessToken: computed(() => this.accessToken),
      routePrefix: computed(() => this.routePrefix),
      currentScope: computed(() => this.currentScope),
    };
  },
  watch: {
      currentScope: {
        handler: function (newVal) {
          if (newVal) {
            this.searchService = new SearchService(this.$jwt.token, newVal);
          }
        },
        deep: true
      },
      accessToken(newVal) {
        if (newVal) {
          this.searchService = new SearchService(newVal, this.currentScope);
        }
      },
    },
  components: {
    SideBarMenu,
  },
  data() {
    const comHandler = new SlaveCommunicationHandler(this);
    return {
      config: Environment,
      searchService: new SearchService(this.$jwt.token, this.currentScope),
      routePrefix: "",
      currentScope: null,
      slaveHandler: comHandler,
      hasNavigation: false,
      uncollapsedWidth: "280px",
      accessToken: null,
      searchReference: null,
      searchResults: [],
      menu: [
        {
          href: "",
          title: "Configuration",
          tcode: "Configuration",
          position: "footer",
          icon: {
            element: "i",
            class: "scf-configuration",
            attributes: { style: "font-size: x-large;" },
          },
          child: [
            {
              href: "/DmPortal/client",
              tcode: "ClientManagement",
              requiredRoles: ["dm-client-read", "dm-client-write", "dm-administrator"],
              title: computed(() => this.$t("sideMenu.ClientManagement")),
            },
          ],
        },
        {
          //A menu item that has child (sub-menu)diagnosys
          href: "",
          title: computed(() => this.$t("sideMenu.ClientInventory")),
          tcode: "ClientInventory",
          icon: {
            element: "i",
            class: "scf-patrimoine",
            attributes: { style: "font-size: x-large;" },
          },
          child: [
            //here you declare your childs
            {
              href: "/DmPortal/equipmentlist",
              tcode: "EquipementList",
              requiredRoles: ["dm-administrator", "dm-assets-read"],
              title: computed(() => this.$t("sideMenu.EquipementList")),
            },
            {
              href: "/DmPortal/FileProcessing",
              tcode: "DeviceImportList",
              requiredRoles: ["dm-administrator", "dm-assets-read"],
              title: computed(() => this.$t("sideMenu.DeviceImportList")),
            },
            {
              href: "/DmPortal/PatrimoineList",
              tcode: "PatrimoineList",
              requiredRoles: ["dm-administrator", "dm-assets-read"],
              title: computed(() => this.$t("sideMenu.PatrimoineList")),
            },
          ],
        },
        {
          //A menu item that has child (sub-menu)diagnosys
          href: "",
          title: "Firmware",
          tcode: "Firmware",
          icon: {
            element: "i",
            class: "scf-traced",
            attributes: { style: "font-size: x-large;" },
          },
          child: [
            //here you declare your childs
            {
              href: "/DmPortal",
              tcode: "FirmwareAdd",
              requiredRoles: ["dm-administrator", "dm-ufw-write"],
              title: computed(() => this.$t("sideMenu.FirmwareAdd")),
            },
            {
              href: "/DmPortal/firmwarelist",
              tcode: "FirmwareList",
              requiredRoles: ["dm-administrator", "dm-ufw-read", "dm-ufw-write"],
              title: computed(() => this.$t("sideMenu.FirmwareList")),
            },
            {
              href: "/DmPortal/compaignadd",
              tcode: "CompaignAdd",
              requiredRoles: ["dm-administrator", "dm-ufw-write"],
              title: computed(() => this.$t("sideMenu.CompaignAdd")),
            },
            {
              href: "/DmPortal/compaignlist",
              tcode: "CompaignList",
              requiredRoles: ["dm-administrator", "dm-ufw-read", "dm-ufw-write"],
              title: computed(() => this.$t("sideMenu.CompaignList")),
            },
          ],
        },
      ],
    };
  },
  computed: {
    filteredMenu() {
      const hasRequiredRoles = (item) => {
        if (!item.requiredRoles || item.requiredRoles.length === 0) return true;
        const jwt = this.$jwt;
        if (!jwt || typeof jwt.hasAtLeastOneRole !== "function") return false;
        return jwt.hasAtLeastOneRole(item.requiredRoles);
      };

      const filterItems = (items) => {
        return items.reduce((acc, item) => {
          const filteredChildren = item.child ? filterItems(item.child) : [];
          const includeItem =
            hasRequiredRoles(item) || filteredChildren.length > 0;

          if (includeItem) {
            const nextItem = { ...item };
            if (filteredChildren.length > 0) {
              nextItem.child = filteredChildren;
            } else {
              delete nextItem.child;
            }
            acc.push(nextItem);
          }
          return acc;
        }, []);
      };

      // Ensure dependency on access token changes so menu updates after login
      void this.accessToken;
      return filterItems(this.menu);
    },
  },
  methods: {
    searchRef(detail) {
      if (detail.reference == null || detail.reference.length < 4)
        return;
      this.searchReference = detail.reference;
      let auxResults = [];
      this.searchService
          .getPagesResults(this.searchReference)
          .then(res => {
            res.deviceResults.forEach(e => {
              auxResults.push(new SearchResult("DmPortal", e.clientIdentifier, e.foundReference, e.pages));
            });
            this.slaveHandler.SubmitSearchResult("DmPortal", auxResults);
          })
          .catch(() => {
            this.slaveHandler.SubmitSearchResult("DmPortal", auxResults);
          });
    },
    initializeApp() {
      this.lang = this.$el.parentElement.attributes["displayLang"].value;
      this.$i18n.locale = this.lang;

      this.accessToken =
        this.$el.parentElement.attributes["keycloakToken"].value;

      let page = this.$el.parentElement.attributes["page"].value || "/";
      this.$router.push({ path: page });

      this.hasNavigation =
        this.$el.parentElement.attributes["hasNavigation"].value == "true";
    },
    pushRoutePrefix() {
      let routePrefix =
        this.$el.parentElement.attributes["routePrefix"].value || "";
      this.routePrefix = routePrefix;
      if (!routePrefix || routePrefix == null || routePrefix.length == 0)
        return;
      const displayPage =
        this.$el.parentElement.attributes["page"].value || "/home";
      if (routePrefix.endsWith("/")) routePrefix = routePrefix.slice(0, -1);
      const routes = this.$router.getRoutes();
      for (const existingRoute of routes) {
        const route = {
          name: "prefixed_" + existingRoute.name,
          path: routePrefix + existingRoute.path,
          components: existingRoute.components,
        };
        this.$router.addRoute(route);
      }

      this.pageToDisplay = `${routePrefix}${displayPage}`;
    },
    refreshToken(mutations) {
      mutations.forEach((mutation) => {
        if (mutation.type === "attributes") {
          this.accessToken = mutation.target.attributes["keycloakToken"].value;
          this.$jwt.initToken(this.accessToken);
          if (this.$jwt.userProfile.locale) {
            this.$i18n.locale = this.$jwt.userProfile.locale;
          }
        }
      });
    },
  },
    mounted() {
    this.pushRoutePrefix();
    this.initializeApp();
    
    const options = {
      sideBarMenu: this.filteredMenu,
      i18n: useI18n(),
      moduleName: "DmPortal",
    };

    this.slaveHandler.InitCommunication(options, this.refreshToken);
    this.slaveHandler.SubscribeToAmrSearch(this.searchRef);
  },
  created() {
    window.addEventListener("ContextChanged", (e) => {
      this.context = e.detail;
      if (e.detail !== undefined && e.detail !== null) {
        this.context = null;
        if (e.detail.client.scope !== undefined) {
          this.context = e.detail;
          this.currentScope = e.detail.scopes && e.detail.scopes.length > 0 ? e.detail.scopes.join(',') :  e.detail.client.scope.length == 0 ? null : e.detail.client.scope;
          return;
        }
        this.context = e.detail;

      }
    });

    wjcCore.setLicenseKey(this.config.value("VUE_APP_WIJMO_LICENCE"));
  },
});
</script>
<style>
body {
  font-family: D-DIN !important;
}
</style>
<style scoped>
#nav ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  overflow: hidden;
  background-color: #333;
}

#nav li {
  float: left;
}

#nav li a {
  display: block;
  color: white;
  text-align: center;
  padding: 14px 16px;
  text-decoration: none;
}

/* Change the link color to #111 (black) on hover */
#nav li a:hover {
  background-color: #111;
}
body {
  overflow: hidden;
}
.wrapper,
html,
body {
  height: 100vh;
  margin: 0;
}
.wrapper {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.flex-page-container {
  flex: 2;
  display: flex;
  overflow: hidden;
}
.side-menu-container {
  flex: 0;
}
.content-container {
  padding: 10px;
  flex: 1 1;
  overflow: auto;
  overflow-x: hidden;
}
</style>

<style>
.vsm--mobile-bg {
  width: var(--uncollapsed-width) !important;
}
.vsm--child_mobile {
  width: calc(var(--uncollapsed-width) - 65px) !important;
}
</style>
